import { Component, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ExploreActivitiesClassInfoModel } from 'app/shared/models/explore-activities-class-info.model';
import { StartExploringEventModel } from 'app/shared/modals/explore-activities-pick-class-modal/start-exploring-event.model';

@Component({
    selector: 'kh-explore-activities-pick-class-modal',
    templateUrl: './explore-activities-pick-class-modal.component.html',
    styleUrls: ['./explore-activities-pick-class-modal.component.less'],
    standalone: false
})
export class ExploreActivitiesPickClassModalComponent {
  public classes: ExploreActivitiesClassInfoModel[] = [];
  public courseId: string | null = '';
  public isError = false;
  public selectedClass?: ExploreActivitiesClassInfoModel;

  @Output() public onStartExploring = new EventEmitter<StartExploringEventModel>();

  constructor(private readonly bsModalRef: BsModalRef) {}

  public selectClass(classItem: ExploreActivitiesClassInfoModel): void {
    this.selectedClass = classItem;
  }

  public startExploring(): void {
    if (!this.selectedClass) {
      this.isError = true;

      return;
    }

    let courseId = this.courseId || this.selectedClass.CourseId;

    const eventData: StartExploringEventModel = {
      classId: this.selectedClass.ClassId,
      courseId
    };

    this.onStartExploring.emit(eventData);
    this.closeModal();
  }

  public closeModal(): void {
    this.bsModalRef.hide();
  }
}